import { render, staticRenderFns } from "./comm-tools.vue?vue&type=template&id=b647991a"
import script from "./comm-tools.vue?vue&type=script&lang=js"
export * from "./comm-tools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports